<template>
  <v-container fluid>
    <v-row align="center" class="paddingMobile paddingTablet"
      style="padding: 20px 135px 0px 135px; background-color: #050F16;" v-if="parceiro !== undefined">
      <v-col cols="12" md="2" class="d-flex justify-center align-center flex-column">
        <v-img v-if="parceiro.photo != null" contain width="150" height="150" style="border-radius: 50% !important"
          :src="`${$root.$publicUrl}/files/load-image/150/150/${parceiro.photo.id
          }/${sanitizeTitle(parceiro.photo.name)}.${parceiro.photo.extension}`">
        </v-img>
        <v-img v-if="parceiro.photo == null" contain width="150" height="150" style="border-radius: 50% !important"
          src="../assets/imagePlaceHolder.jpeg">
        </v-img>
      </v-col>
      <v-col cols="12" md="10">
        <h1 class="titleScope" style="color: #ff770f">{{ parceiro.name }}</h1>
        <p class="textScope" style="font-weight: 300 !important; color: #fff">
          <small v-for="(c, i) in parceiro.category_user_rels" :key="c.id">
            <span v-if="i > 0">•</span> {{ c.category.name }}
          </small>
        </p>
        <p class="textScope" style="color: #fff">
          Negocia até
          <span>{{
          parceiro.infos !== null
          ? parceiro.infos.accepted_tokens_percentual
          : `0`
          }}%</span>
          em Ribus Token.
        </p>

        <!-- <p class="textScope"><span
                        style="color: #FF770F; font-weight: 600 !important; margin-bottom: 0px !important">159</span>
                    Negócios
                    fechados pela plataforma</p> -->
      </v-col>
      <v-col cols="12" md="5" offset="2" class="d-flex justify-center algin-center flex-column">
      </v-col>
    </v-row>

    <v-row class="paddingTablet paddig0Mobile" style="background-color: #050F16; padding: 20px 150px" justify="center"
      align="center" v-if="parceiro !== undefined">
      <v-col cols="12" md="12" style="padding: 0">
        <v-card class="d-flex flex-column justify-center" width="100%" style="padding: 33px">
          <v-row justify="center" align="center">

          </v-row>
          <v-row v-if="parceiro !== undefined" style="margin-top: 20px">
            <v-col md="12" cols="12" style="padding: 20px">
              <h2 style="color: #050F16; font-size: 18px; font-weight: 500;">Sobre</h2>
              <p>
                {{ parceiro.description }}
              </p>
            </v-col>
            <v-col cols="12" md="12" style="padding: 0px 20px !important">
              <v-row>
                <v-col cols="6" md="6">
                  <h2 v-if="haveSocialMedia" style="color: #050F16; font-size: 18px; font-weight: 500;">
                    Redes sociais
                  </h2>
                  <v-row align="center" v-if="haveSocialMedia" style="margin-top: 5px; padding-left: 8px">
                    <a target="_blank" v-if="parceiro.infos.social.ig" :href="getInstagram">
                      <v-icon large class="socialIcons" color="orange darken-2">
                        mdi-instagram
                      </v-icon>
                    </a>
                    <a target="_blank" v-if="parceiro.infos.social.fb" :href="parceiro.infos.social.fb">
                      <v-icon large class="socialIcons" color="orange darken-2">mdi-facebook</v-icon>
                    </a>
                    <a target="_blank" v-if="parceiro.infos.social.linkedin" :href="parceiro.infos.social.linkedin">
                      <v-icon large class="socialIcons" color="orange darken-2">mdi-linkedin</v-icon>
                    </a>
                  </v-row>
                </v-col>

                <v-col cols="6" md="6">
                  <div v-if="parceiro.infos !== null" class="" style="">
                    <h2 style="color: #050F16; font-size: 18px; font-weight: 500;">Site</h2>
                    <a target="_blank" v-if="parceiro.infos.social.site" :href="getSite">
                      <v-icon large class="socialIcons" color="orange darken-2">
                        mdi-web
                      </v-icon>
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <v-col class="mt-mob" cols="12" md="12">
              <v-row>
                <!-- <v-col cols="12" md="1" class="d-flex flex-column justify-center">
                                    <v-icon style="color: #FF770F; font-size: 58px;">mdi-map-marker</v-icon>
                                </v-col> -->
                <h2 class="textScope" style="font-weight: 600 !important">
                  {{ parceiro.address !== null ? parceiro.address.city : "" }}
                </h2>

                <!-- <p class="textScope">Lorem lorem lorem loremlorem</p> -->
                <iframe v-if="parceiro.address !== null"
                  :src="`https://www.google.com/maps?output=embed&amp;q=${parceiro.address.street}${parceiro.address.number} - ${parceiro.address.city}&amp;z=16&amp;t=m`"
                  width="100%" height="200" style="border: 0" allowfullscreen="" loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"></iframe>
              </v-row>
              <entrarContato v-if="$root.$environment !== `staging`" :destinatario="parceiro"></entrarContato>

            </v-col>
          </v-row>

          <div>
            <v-row style="margin-top: 0px;">
              <v-col cols="12" md="12">
                <h2 style="color: #050F16; font-size: 18px; font-weight: 500;">Serviços e produtos oferecidos</h2>
                <!-- <p style="margin-bottom: 0px !important;">Lorem ipsum dolor sit amet consectetur adipisicing elit,
                  reprehenderit reiciendis quas dolore quod sapiente.</p> -->
              </v-col>

              <v-col cols="12" md="12">
                <v-row style="margin-top: 0px; border-radius: 20px; border: 1px solid #bfbfbf; padding: 20px;">
                  <v-tabs grow v-model="tab" align-with-title>
                    <v-tabs-slider color="orange"></v-tabs-slider>
                    <v-tab style="color: #000" v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab" style="">
                    <v-tab-item>
                      <v-row>
                        <CardImovel v-for="p in produtos" :key="p.id" :imovel="p" :categoria="`imoveis`"></CardImovel>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item>
                      <v-row>
                        <v-img src="../assets/gif.gif" width="300"></v-img>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item style="width: 100% !important;">
                      <v-row>
                        <v-col v-for="s in servicos" :key="s.id">
                          <v-card max-width="300" class="mx-auto" outlined>
                            <v-carousel hide-delimiter-background dark delimiter-icon="mdi-minus" style="height: 221px"
                              light id="cases" class="d-flex justify-center flex-column pt5" v-if="s.files.length > 0">
                              <template v-slot:prev="{ on, attrs }">
                                <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-left</v-icon>
                              </template>
                              <template v-slot:next="{ on, attrs }">
                                <v-icon v-on="on" v-bind="attrs" color="white">mdi-arrow-right</v-icon>
                              </template>

                              <v-carousel-item v-for="(img, i) in s.files" :key="i">
                                <v-sheet tile style="background-color: transparent">
                                  <v-row align="center">
                                    <v-col cols="12" md="12">
                                      <!-- <v-img width="100%" height="221px" max-height="221px" v-if="img.file_storage != undefined" :src="`${$root.$publicUrl}/files/load-full-image/${img.file_storage.id}/${$root.$options.filters.sanitizeTitle(img.file_storage.name)}
                                    .${img.file_storage.extension}`">
                                      <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                          <v-progress-circular indeterminate color="#ff770f70"></v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img> -->
                                      <v-img width="100%" height="221px" max-height="221px" v-if="img.url != undefined"
                                        :src="img.url">
                                        <template v-slot:placeholder>
                                          <v-row class="fill-height ma-0" align="center" justify="center">
                                            <v-progress-circular indeterminate color="#ff770f70"></v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                    </v-col>
                                  </v-row>
                                </v-sheet>
                              </v-carousel-item>
                            </v-carousel>
                            <v-card-title>
                              {{s.title}} <small>{{s.short_description}}</small>
                            </v-card-title>
                            <v-card-text>
                              {{s.description}}

                            </v-card-text>
                            <v-card-actions>
                            </v-card-actions>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card>


          
          <v-row style="">
            <v-col cols="12" md="12">
              <v-card v-if="$root.$environment === `staging`" class="d-flex flex-column justify-center" width="100%"
              style="padding: 5px; background-color: #fff; margin-top: 20px">
                <v-card-title class="" style="border-bottom: 2px solid #d7531f; padding: 0px !important">
                  <v-col cols="12" md="12" class="d-flex align-center">
                    <v-avatar size="62" class="mr-3">
                      <v-img v-if="parceiro.photo != null" contain width="150" height="150" style="border-radius: 50% !important"
                        :src="`${$root.$publicUrl}/files/load-image/150/150/${parceiro.photo.id
                        }/${sanitizeTitle(parceiro.photo.name)}.${parceiro.photo.extension}`">
                      </v-img>
                      <v-img v-if="parceiro.photo == null" contain   style="border-radius: 50% !important"
                        src="../assets/imagePlaceHolder.jpeg">
                      </v-img>
                    </v-avatar>
                    <div>
                      <h2>{{ parceiro.name }}</h2>
                    </div>
                  </v-col>
                </v-card-title>

                <!-- <chatWindow v-if="parceiro.id !== undefined && isLoggedIn" :partner="parceiro"></chatWindow> -->

                </v-card>       
            </v-col>
          </v-row>        
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// import chatWindow from "../components/chatWindow.vue";
import CardImovel from "../components/cardImovel.vue";
// import chat from '../components/chat.vue';
export default {
  name: "perfilParceiro",

  components: { CardImovel },
  Chatprops: { destinatario: Object },

  data: () => ({
    tab: 2,
    message: "",
    loading: false,

    items: [
      'Imóveis', 'Cursos', 'Serviços'
    ],
    text: '',
    parceiro: {
      categories: [],
      infos: { accepted_tokens_percentual: 0, social: {} },
      description: "",
      address: { city: "" },
      photo: null,
      name: "",
    },

    produtos: [],
    servicos: []
  }),

  computed: {

    isLoggedIn() {
      return this.$store.state.user.login !== undefined
    },

    haveSocialMedia() {
      if ((this.parceiro.infos !== null) && (this.parceiro.infos.social !== undefined)) {
        return (
          [undefined, ""].indexOf(this.parceiro.infos.social.ig) === -1 ||
          [undefined, ""].indexOf(this.parceiro.infos.social.fb) === -1 ||
          [undefined, ""].indexOf(this.parceiro.infos.social.linkedin) === -1
        );
      }
      else {
        return false
      }
    },
    getSite() {
      if (this.parceiro.infos.social.length > 0) { 
      return this.parceiro.infos.social.site.indexOf("https://") > -1 ||
        this.parceiro.infos.social.site.indexOf("http://") > -1 ?
        this.parceiro.infos.social.site :
        "https://" + this.parceiro.infos.social.site
      }
      else { 
        return null
      }
    },
    getInstagram() {
      if (this.parceiro.infos.social.length > 0) { 

      return this.parceiro.infos.social.ig.indexOf("https://") === 0 || this.parceiro.infos.social.ig.indexOf("http://") === 0 ?
        this.parceiro.infos.social.ig :
        'https://instagram.com/' + this.parceiro.infos.social.ig.replace("@", "")
      }
      else { 
        return ""
      }
    }
  },
  metaInfo() {
    return {
      title: this.parceiro != undefined ? this.parceiro.name : "Parceiro"
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.idParceiro) {
      let tmpParceiro =this.$store.getters.parceiroById(
        this.$route.params.idParceiro
      );
      if (tmpParceiro) { 
        tmpParceiro.infos = typeof tmpParceiro.infos === undefined ?  {social:{}} : 
                          typeof tmpParceiro.infos !== "object" ? JSON.parse(tmpParceiro.infos) : 
                          tmpParceiro.infos
        this.parceiro = tmpParceiro
      
      }
    }
  },
  watch: {
    parceiro: function (nValue) {
      if (nValue) {
        this.$http.get('/products?type=PROPERTY&user_id=' + nValue.id).then(res => {
          this.produtos = res.data.result.products
        })
        this.$http.get('/products?type[]=PHYSICAL_PRODUCT&user_id=' + nValue.id).then(res => {
          this.servicos = res.data.result.products
        })
      }
    },
    "$store.state.parceiros": {
      handler: function () {
        this.parceiro = this.$store.getters.parceiroById(
          this.$route.params.idParceiro
        );
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {


    sanitizeTitle: function (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  },
};
</script>

<style scope>
@media (min-device-width: 820px) and (max-device-width: 1200px) {
  .displayTablet {
    justify-content: flex-end !important;
  }

  .paddingTablet {
    padding: 60px 10px !important;
  }

  .offset-2 {
    margin-left: 0% !important;
  }
}

@media (min-device-width: 300px) and (max-device-width: 731px) {
  .btnMobile{
        height: 40px !important;
        width: 100% !important;
    }

    .heightMobile {
        min-height: 60vh !important;
        max-height: 60vh !important;
    }

    .heightCarouselMob{
        height: 100vh !important;
    }

  .mt-mob {
    margin-top: 20px;
  }

  .paddig0Mobile {
    padding: 0 !important;
  }

  .mt20Mob {
    margin-top: 20px;
  }

  .paddigMobile {
    padding: 0px 10px !important;
  }

  .paddingMobile {
    padding: 60px 10px 0px !important;
  }

  .offset-2 {
    margin-left: 0% !important;
  }
}


.StyleButton {
  background-color: #ff770fe0 !important;
  color: #fff;
  font-family: "Poppins";
  border-radius: 50px;
  margin-top: 20px;
}

.titleCarrocel {
  font-size: 28px;
  font-family: "Poppins";
  font-weight: 500;
  color: #fff;
  text-align: left;
}

.titleScope {
  font-size: 32px;
  font-family: "Poppins";
  line-height: 1;
  font-weight: 800;
  text-align: left;
}

.textScopeDepoiments {
  margin-bottom: 0px;
  font-size: 15px;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
}

.textScope {
  margin-bottom: 0px;
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 300;
  text-align: left;
}
</style>
